import Shimmer from "@/utils/shimmer";
import Image from "next/image";
import { ITestimonialItem } from "./interfaces";
import FaQuoteLeft from "../SVG/Fontawesome/FaQuoteLeft";

export const TestimonialItem = (props: {
  user: ITestimonialItem;
  index: number;
}) => {
  const { user } = props;

  return (
    <div className="relative z-0 max-w-[17rem] shrink-0 h-full snap-center py-5 px-6 bg-secondary mt-4 rounded-md flex flex-col gap-5">
      <div className="flex items-center mb-2">
        <div className="text-primary text-3xl absolute top-0 left-4 -translate-y-4 z-99">
          <FaQuoteLeft className="text-accent" />
        </div>
        <div className="h-48">
          <p className="overflow-hidden line-clamp-6 font-medium leading-relaxed my-0">
            {user.description}
          </p>
        </div>
      </div>
      <div className="flex items-center mt-4">
        <div className="w-8 h-8 overflow-hidden  rounded-full border-2 border-gray-300 mr-4">
          {user.imageUrl && (
            <Image
              src={user.imageUrl}
              alt="user portrait"
              width={48}
              height={48}
              placeholder="blur"
              blurDataURL={Shimmer(48, 48)}
              className="mt-0"
            />
          )}
        </div>
        <div className="flex flex-col">
          {user.name && <span className="w-32 text-base font-semibold whitespace-nowrap overflow-hidden text-ellipsis">{user.name}</span>}
          {/* {user.rank && <span className="text-xs font-medium">{user.rank}</span> } */}
        </div>
      </div>
    </div>
  );
};
